module.exports = __webpack_public_path__ + "static/media/en.ad64eb36.svg";